import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import BaseModulePlugins from '@/store/baseModule/plugins';
import makeSeveralCurrentsModule from '@/store/severalCurrentsModule';
import setTechnicianAffected from '@/store/modules/requests/setTechnicianAffected';
import RequestsService from '@/services/services/requests.service';
import { PURPOSE_LIST } from '@/store/modules/properties/constants';

export const REQUEST_STATES = [
  { id: '1', name: "Attente d'affectation technicien" },
  { id: '2', name: 'Attente prise en charge' },
  { id: '3', name: "Attente retour d'intervention" },
  { id: '5', name: 'Demande client à clôturer' },
  { id: '9', name: 'Demande client clôturée' },
];

export const ATTRIBUTES_OBJ_REF_REQUESTS_TREATED = {
  transformable_request: {
    serverSide: true,
    values: [
      {
        id: 'O',
        name: 'Oui',
      },
      {
        id: 'N',
        name: 'Non',
      },
    ],
  },
  customer_type: {
    autocomplete: true,
    serverSide: true,
    values: [
      { id: 'CLI', name: 'CLI - Client' },
      { id: 'CRG', name: 'CRG - Concierge' },
      { id: 'POR', name: 'POR - Portail Client' },
      { id: 'LOC', name: 'LOC - Locataire - propiétaire' },
      { id: 'TEC', name: 'TEC - Technicien' },
      { id: 'TTS', name: 'TTS - Transmetteur de télésurveillance' },
      { id: 'SST', name: 'SST - Société de surveillance' },
      { id: 'XXX', name: 'XXX - Autre' },
    ],
  },
  status: {
    autocomplete: true,
    serverSide: true,
    values: REQUEST_STATES,
  },
  rejected: {
    serverSide: true,
    values: [
      { id: 'O', name: 'Oui' },
      { id: 'N', name: 'Non' },
    ],
  },
  transmitted: {
    serverSide: true,
    values: [
      { id: 'O', name: 'Oui' },
      { id: 'N', name: 'Non' },
    ],
  },
  purpose: {
    autocomplete: true,
    serverSide: true,
    values: PURPOSE_LIST,
  },
  work_order_group_type_name: {
    noFilter: true,
    type: '$instr',
    values: [],
  },
  customer_name: {
    noFilter: true,
    type: '$instr',
    values: [],
  },
  dispatcher_userid: {
    noFilter: true,
    values: [],
  },
  request_customer_type: {
    serverSide: true,
    autocomplete: true,
    values: [
      { id: 'STANDARD', name: 'Standard' },
      { id: 'AUTO', name: 'Auto' },
      { id: 'PREMIUM', name: 'Premium' },
    ],
  },
};

const ATTRIBUTES_OBJ_REQUESTS_TREATED = {
  status: {
    serverSide: true,
    values: ['2'],
  },
  rejected: {
    serverSide: true,
    values: ['N'],
  },
  work_order_group_type_name: {
    serverSide: true,
    values: [],
    type: '$instr',
  },
  customer_name: {
    serverSide: true,
    values: [],
    type: '$instr',
  },
  dispatcher_userid: {
    serverSide: true,
    values: [],
  },
  request_customer_type: {
    serverSide: true,
    values: [],
  },
};

const customFunc = (AndQueryParams) => {
  AndQueryParams.push({
    $and: [
      {
        status: {
          $ne: '0',
        },
      },
      {
        $or: [
          {
            $and: [
              {
                status: {
                  $eq: '1',
                },
              },
              {
                rejected: {
                  $eq: 'O',
                },
              },
            ],
          },
          {
            status: {
              $eq: '2',
            },
          },
          {
            status: {
              $eq: '3',
            },
          },
          {
            status: {
              $eq: '5',
            },
          },
          {
            status: {
              $eq: '9',
            },
          },
        ],
      },
    ],
  });
};

const TREATED_REQUESTS_MODULE_NAME = ['requests', 'treated'];
const TREATED_REQUESTS_MODULE_PATH = 'requests/treated';
export { TREATED_REQUESTS_MODULE_NAME, TREATED_REQUESTS_MODULE_PATH };
export default (store) => {
  store.registerModule(
    TREATED_REQUESTS_MODULE_NAME,
    makeSeveralCurrentsModule({
      attributesObjRef: ATTRIBUTES_OBJ_REF_REQUESTS_TREATED,
      attributesObj: ATTRIBUTES_OBJ_REQUESTS_TREATED,
      customActions: {
        setTechnicianAffected,
      },
      hasDefaultFilters: true,
      searchAttributesArray: ['id', 'property_code', 'property_name'],
      defaultSortBy: ['signalisation_datetime'],
      serviceAPI: RequestsService,
      makeQueryParams: makeListRequest({
        dateField: 'signalisation_datetime',
        useEntities: true,
        customFunc,
      }),
    })
  );

  const basePlugin = new BaseModulePlugins({
    module: TREATED_REQUESTS_MODULE_PATH,
    store,
  });

  basePlugin.initAttributeFiltersWhenAttributesObjRefIsLoaded({});

  basePlugin.persistVuexMutationsToLocalStorage([
    'SET_ATTRIBUTES_OBJ',
    'SET_VIEW_TABLE',
  ]);
  store.subscribe((mutation) => {
    if (mutation.type === 'entities/SET_CURRENT') {
      store.dispatch(`${TREATED_REQUESTS_MODULE_PATH}/setFilterAttribute`, {
        attribute: 'dispatcher_userid',
        values: [],
        useDelay: true,
      });
      store.dispatch(`${TREATED_REQUESTS_MODULE_PATH}/setGlobalSearch`, null);
    }
  });
};
